"use client";

import React from "react";
import { v3, inkAccent } from "@/lib/theme";
import { TOTALS, PORTFOLIO, VALUE_SERIES, fmtEur, fmtPct } from "@/lib/data/mock";
import { Sparkline } from "@/components/ui/charts";
import { V3SectionHead } from "./V3SectionHead";
import { motion } from "framer-motion";

function V3ExcelMess() {
  const cells = ["A", "B", "C", "D", "E", "F", "G"];
  const rows = [
    ["Objekt 1", "1070",   "=B2*0,04/12", "1.140", "#REF!",  "850",   ""],
    ["Obj 2",    "1020",   "1680",         "",      "1520",   "130",   "v3 final"],
    ["objekt 3", "Graz",   "720",          "640",   "",       "70",    "?"],
    ["Objekt 4", "WIEN10", "1250",         "1180",  "105",    "−35",   ""],
    ["#5",       "Linz",   "=SUM(C2:C5)?", "1310",  "145",    "35",    "TODO"],
    ["",         "",       "GESAMT?",      "",      "",       "",      ""],
    ["Notiz:",   "Marktwert von Makler 2022 — bitte updaten",  "", "", "", "", ""],
  ];
  return (
    <div style={{ background: "#1d1f25", height: "100%", display: "flex", flexDirection: "column", minWidth: 800 }}>
      <div style={{ background: "#2c2f37", padding: "10px 16px", borderBottom: `1px solid ${v3.line2}`, display: "flex", gap: 14, font: `12px ${v3.sans}`, color: v3.dim }}>
        <span style={{ color: v3.fg2 }}>Portfolio v3 final FINAL FINAL.xlsx</span>
        <span style={{ color: "#d97757" }}>● ungespeicherte Änderungen</span>
        <span style={{ marginLeft: "auto", color: v3.dim2 }}>Tabelle 1 · Tabelle 2 · Tabelle 3 · Tabelle 4 · Tabelle 5</span>
      </div>
      <div style={{ flex: 1, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", font: `12.5px ${v3.mono}`, color: v3.fg2 }}>
          <thead>
            <tr style={{ background: "#23262d", color: v3.dim }}>
              <th style={{ width: 36, padding: 6, borderRight: `1px solid #2a2d35`, borderBottom: `1px solid #2a2d35`, fontWeight: 400 }}></th>
              {cells.map((c, i) => (
                <th key={i} style={{ padding: 6, borderRight: `1px solid #2a2d35`, borderBottom: `1px solid #2a2d35`, fontWeight: 400, textAlign: "left" }}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, ri) => (
              <tr key={ri}>
                <td style={{ padding: 8, color: v3.dim, background: "#23262d", textAlign: "center", borderRight: `1px solid #2a2d35`, borderBottom: `1px solid #2a2d35` }}>{ri + 1}</td>
                {r.map((c, ci) => {
                  let style: any = { padding: 8, borderRight: `1px solid #2a2d35`, borderBottom: `1px solid #2a2d35` };
                  if (c === "#REF!" || c === "?") style.color = "#d97757";
                  if (c.toString().startsWith("=")) style.color = "#a3b8d8";
                  if (c === "TODO" || c === "v3 final") { style.background = "#3a2f1a"; style.color = "#e0c068"; }
                  return <td key={ci} style={style}>{c}</td>;
                })}
              </tr>
            ))}
            <tr>
              <td style={{ padding: 8, color: v3.dim, background: "#23262d", textAlign: "center", borderRight: `1px solid #2a2d35`, borderBottom: `1px solid #2a2d35` }}>9</td>
              <td colSpan={7} style={{ padding: 12, color: "#d97757", borderBottom: `1px solid #2a2d35`, font: `12px ${v3.sans}` }}>
                ⚠ Formel in C9 verweist auf gelöschten Bereich. Marktwert seit 14 Monaten nicht aktualisiert.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function V3RealpilotClean() {
  const ink = inkAccent();
  return (
    <div style={{ background: v3.bg, height: "100%", padding: 28, minWidth: 800 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 18 }}>
        <span className="v3-pulse animate-pulse" style={{ width: 6, height: 6, borderRadius: 99, background: v3.accent, boxShadow: `0 0 8px ${v3.accent}` }} />
        <span style={{ font: `12px ${v3.sans}`, color: v3.fg }}>Portfolio · Anna G.</span>
        <span style={{ marginLeft: "auto", font: `11px ${v3.mono}`, color: v3.dim }}>Live · heute 17:42</span>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12 }}>
        {[
          ["Portfoliowert", fmtEur(TOTALS.wert),  fmtPct(TOTALS.wertstgPct)],
          ["Rendite Ø",     `${TOTALS.rendite.toFixed(2).replace(".", ",")} %`, "stabil"],
          ["Cashflow",      fmtEur(TOTALS.cf, { sign: true }), "monatlich"],
          ["Objekte",       "6", "alle gepflegt"],
        ].map((k, i) => (
          <div key={i} style={{ background: v3.surf, border: `1px solid ${v3.line}`, borderRadius: 10, padding: 14 }}>
            <div style={{ font: `11px ${v3.sans}`, color: v3.dim }}>{k[0]}</div>
            <div style={{ font: `500 22px ${v3.sans}`, color: v3.fg, marginTop: 6, letterSpacing: "-0.02em" }}>{k[1]}</div>
            <div style={{ font: `11px ${v3.mono}`, color: ink, marginTop: 2 }}>{k[2]}</div>
          </div>
        ))}
      </div>
      <div style={{ marginTop: 18, background: v3.surf, border: `1px solid ${v3.line}`, borderRadius: 10, padding: 18 }}>
        <div style={{ font: `12px ${v3.sans}`, color: v3.dim, marginBottom: 12 }}>Portfoliowert · 24M</div>
        <div style={{ color: ink }}>
          <Sparkline data={VALUE_SERIES} height={120} width={1200} stroke={ink} fill={v3.intense ? v3.accentBg : "rgba(250,250,250,0.04)"} strokeWidth={1.6} dots />
        </div>
      </div>
      <div style={{ marginTop: 18, display: "grid", gridTemplateColumns: "repeat(6, 1fr)", gap: 8 }}>
        {PORTFOLIO.map((o) => (
          <div key={o.id} style={{ background: v3.surf, border: `1px solid ${v3.line}`, borderRadius: 8, padding: "10px 12px" }}>
            <div style={{ font: `10px ${v3.mono}`, color: v3.dim2 }}>#{String(o.id).padStart(2, "0")}</div>
            <div style={{ font: `12.5px ${v3.sans}`, color: v3.fg, marginTop: 2, fontWeight: 500 }}>{o.city}</div>
            <div style={{ font: `11px ${v3.mono}`, color: ink, marginTop: 4 }}>{o.rendite.toFixed(2).replace(".", ",")} %</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function V3SectionExcel() {
  const [split, setSplit] = React.useState(50);
  const containerRef = React.useRef<HTMLDivElement>(null);
  const draggingRef = React.useRef(false);

  const [auto, setAuto] = React.useState(true);
  React.useEffect(() => {
    if (!auto) return;
    let raf: number;
    let t0 = performance.now();
    const tick = (t: number) => {
      const phase = ((t - t0) / 6000) % 1;
      const target = 50 + Math.sin(phase * Math.PI * 2) * 28;
      setSplit(target);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [auto]);

  const handleDown = (e: any) => {
    draggingRef.current = true;
    setAuto(false);
    const move = (ev: any) => {
      if (!draggingRef.current || !containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const x = (ev.touches ? ev.touches[0].clientX : ev.clientX) - rect.left;
      setSplit(Math.max(2, Math.min(98, (x / rect.width) * 100)));
    };
    const up = () => {
      draggingRef.current = false;
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", up);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchmove", move);
    window.addEventListener("touchend", up);
    move(e);
  };

  return (
    <motion.section 
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      style={{ padding: "120px 56px", background: v3.surf2, borderTop: `1px solid ${v3.line}`, borderBottom: `1px solid ${v3.line}` }} className="rp-section"
    >
      <V3SectionHead n={4} kicker="Schluss mit Excel"
        title="Du verdienst mehr"
        dimWord="als eine Tabelle."
        sub="Zieh den Schieber. Links: was du heute hast. Rechts: was möglich ist." />

      <div ref={containerRef} style={{ position: "relative", width: "100%", height: 540, background: v3.bg, border: `1px solid ${v3.line2}`, borderRadius: 16, overflow: "hidden", userSelect: "none", cursor: draggingRef.current ? "grabbing" : "default" }}>
        {/* Excel side (full width, base layer) */}
        <div style={{ position: "absolute", inset: 0, overflowX: "auto" }}>
          <V3ExcelMess />
        </div>
        {/* realpilot side — clipped to the right of the divider */}
        <div style={{ position: "absolute", inset: 0, clipPath: `inset(0 0 0 ${split}%)`, overflowX: "auto" }}>
          <V3RealpilotClean />
        </div>
        {/* Divider */}
        <div
          onMouseDown={handleDown}
          onTouchStart={handleDown}
          style={{
            position: "absolute", top: 0, bottom: 0, left: `${split}%`,
            width: 2, background: v3.accent, transform: "translateX(-1px)",
            boxShadow: `0 0 24px ${v3.accent}`, cursor: "ew-resize", zIndex: 10,
          }}>
          <div style={{
            position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
            width: 44, height: 44, borderRadius: 99,
            background: v3.accent, color: v3.bg,
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: `0 8px 24px rgba(0,0,0,.5), 0 0 0 8px ${v3.accentBg}`,
            cursor: "grab",
          }}>
            <svg viewBox="0 0 20 20" width="18" height="18">
              <path d="M7 5 L2 10 L7 15 M13 5 L18 10 L13 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
        </div>
        {/* Labels */}
        <div className="hidden sm:block" style={{ position: "absolute", top: 16, left: 24, font: `11px ${v3.mono}`, color: v3.dim, letterSpacing: "0.12em", textTransform: "uppercase", zIndex: 9 }}>
          ◀ Excel.xlsx · so läuft es
        </div>
        <div className="hidden sm:block" style={{ position: "absolute", top: 16, right: 24, font: `11px ${v3.mono}`, color: v3.accent, letterSpacing: "0.12em", textTransform: "uppercase", zIndex: 9 }}>
          realpilot · so läuft es bei dir ▶
        </div>
      </div>
    </motion.section>
  );
}
